import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ChevronRight } from "lucide-react";

const ease = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.8, delay, ease }}
  >
    {children}
  </motion.div>
);

export const MaskTitle = ({ lines, as: Tag = "h1", className = "", testId, delay = 0.1 }) => (
  <Tag data-testid={testId} className={`headline ${className}`}>
    {lines.map((l, i) => (
      <span key={l} className="block overflow-hidden pb-[0.06em]">
        <motion.span
          className="block"
          initial={{ y: "105%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1, delay: delay + i * 0.1, ease: [0.76, 0, 0.24, 1] }}
        >
          {l}
        </motion.span>
      </span>
    ))}
  </Tag>
);

export const Eyebrow = ({ children, className = "" }) => <p className={`eyebrow ${className}`}>{children}</p>;

const base = "group inline-flex items-center justify-center gap-3 px-9 py-3.5 font-head font-semibold text-[15px] transition-colors duration-300";
const styles = {
  solid: "bg-[var(--ink)] text-white hover:bg-[#2a2a2a]",
  outline: "border-2 border-[var(--ink)] text-[var(--ink)] hover:bg-[var(--ink)] hover:text-white",
};

export const Btn = ({ to, onClick, children, variant = "solid", testId, chevron = true, type = "button", disabled, className = "" }) => {
  const cls = `${base} ${styles[variant]} ${className}`;
  const inner = (
    <>
      {children}
      {chevron && <ChevronRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />}
    </>
  );
  if (to) return <Link to={to} data-testid={testId} className={cls}>{inner}</Link>;
  return <button type={type} onClick={onClick} disabled={disabled} data-testid={testId} className={`${cls} disabled:opacity-60`}>{inner}</button>;
};

export const HeroImage = ({ src, alt, testId, className = "" }) => (
  <motion.div
    data-testid={testId}
    initial={{ clipPath: "inset(0 0 0 100%)" }}
    animate={{ clipPath: "inset(0 0 0 0%)" }}
    transition={{ duration: 1.3, delay: 0.2, ease: [0.76, 0, 0.24, 1] }}
    className={`relative overflow-hidden ${className}`}
  >
    <motion.img
      src={src}
      alt={alt}
      initial={{ scale: 1.15 }}
      animate={{ scale: 1 }}
      transition={{ duration: 1.8, delay: 0.2, ease }}
      className="absolute inset-0 h-full w-full object-cover"
    />
  </motion.div>
);
